import React, { Fragment, useEffect } from "react";
import { FormContainer } from "../../parts/form-container/FormContainer";
import warningImage from "../../assets/images/icon-sign-in.svg";
import { FormFooter } from "../../parts/form-footer/FormFooter";

export const NotFound = () => {
  const PAGE_NAME = "notfound";

  useEffect(() => {
    document.title = "Page not found | Simplyhealth";
  }, []);

  return (
    <FormContainer
      pageName={PAGE_NAME}
      title="404"
      messages={["Sorry, page not found."]}
      image={<img src={warningImage} alt="Not Found logo" />}
      fields={<Fragment />}
      action={<Fragment />}
      footer={<FormFooter message="New to Simplyhealth?" linkText="Register" redirectTo="/register" />}
    />
  );
};
